<template>
    <ul class="d-flex list-unstyled tabs-list mb-0">
        <li
            v-for="tab in tabs"
            :class="{ active: route().current('dashboard.show', { id: tab.slug }) || route().current('dashboard.index') }"
            class="tab-item"
        >
            <a :href="route('dashboard.show', { id: tab.slug })" @click.prevent="$inertia.visit(route('dashboard.show', { id: tab.slug }))">
                {{ trans(tab.name) }}
            </a>
        </li>
    </ul>
</template>

<script setup>
import { trans } from '@/mixins/i18n.js';
const props = defineProps({
    tabs: {
        type: [Array, Object],
        required: true,
        default: () => [],
    },
});
</script>
